import { render, staticRenderFns } from "./mainDealerStock.vue?vue&type=template&id=620ac05b&scoped=true"
import script from "./mainDealerStock.vue?vue&type=script&lang=js"
export * from "./mainDealerStock.vue?vue&type=script&lang=js"
import style0 from "./mainDealerStock.vue?vue&type=style&index=0&id=620ac05b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ac05b",
  null
  
)

export default component.exports